<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير الحضور والغياب'" :to="{name: 'reports.lessonAbsences'}">  تفاصيل تقرير الحضور والغياب</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تفاصيل تقرير الحضور والغياب
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <div class="table-responsive" >
                                  <div class="col-md-12 mb-2">
                                    <button class="btn btn-success" v-if="data.data.length" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  </div>
                                  <div class="col-md-12" id="printMe">
                                    

                                  <table class="table table-bordered mb-4" v-if="data.data.length">
                                        <thead>
                                           <tr>
                                            <th>اسم الطالب</th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(deg, i) in data.data" :key="i">
                                            <td>{{ deg }}</td>
                                          </tr>
                                          
                                        </tbody>
                                        <tfoot>
                                          <tr >
                                            <th colspan="2" class="text-center">الاجمالى</th>
                                          </tr>
                                          <tr >
                                            <th colspan="2" class="text-center">{{ data.total.count }}</th>
                                          </tr>
                                        </tfoot>
                                    </table>
                                  </div>
                                  <div class="col-md-12">
                                    <button class="btn btn-success" v-if="data.data.length" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  </div>
                                 
                                    
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapGetters } from 'vuex'


export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      isRequested: false,

      chartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            labels: ['اجمالى الحضور', 'اجمالى الغياب', 'اجمالى الاستأذان', 'اجمالى التأخير'],
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            legend: {
              formatter: function(val, opts) {
                return val + " - " + opts.w.globals.series + '%'
              }
            },
            title: {
              text: ''
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      printData: {
      },
      data: {
        data: {},
        info: {},
        total: {count: 0},
        searching:{
            group_id: '',
            lesson_id: '',
            student_id: '',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
    this.getIndexData(1);
  },
  methods: {
    getLabelById(arr, id){
      if(arr.length){
        for (let index = 0; index < arr.length; index++) {
        let element = arr[index];
        if(element.id == id){
          return element.label;
        }
        
      }
      }
      
      return '';
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', 'تفاصير تقرير الحضور والغياب');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/reports/absences?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
              if(type == 'student'){
                this.students = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/reports/absences?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    
    getLessons(val){
      this.$baseApi.get('/reports/absences?pluck=1&group='+val.id+'&i='+val.id+'&pluckType=lesson').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lessons = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStudents(val){
      this.$baseApi.get('/reports/absences?pluck=1&lesson='+this.data.searching.lesson_id+'&i='+val.id+'&pluckType=student').then((response)=>{
            
            if(response.data.code == 200){
              
              this.students = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        let lessonId = this.$route.query.i;
        let type  = this.$route.query.type;
        let dt  = this.$route.query.d;
        if(!lessonId|| !type || !dt){
          alert('خطأ فى البيانات');
          return;
        }
        this.isRequested = true;
        this.$baseApi.get('/reports/student-lesson-absences?data=' + 1, {
                    params: {
                      type: type,
                      date_from: dt,
                      lesson_id: lessonId
                    }
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.data = response.data.data.data;
              this.data.total.count = response.data.data.count;
              this.isRequested = false;
              
            }else{
                alert(response.data.error.error);
                this.isRequested = false;

            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return (n/t) * 100;
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    ...mapGetters({
      settings: 'GET_WEBSITE_SETTING_KEYS'
    })
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
